import data from "./tray.mjs";
//#region src/locales/vi/tamagotchi/electron/index.ts
var electron_default = { tray: data };
//#endregion
export { electron_default as default };
